import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';
import { IconButton } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import './ToggleViewButton.scss';

const ToggleViewButton = ({ onClick, isViewTable, className }) => {
  const classes = classNames('toggle-view-button', className);
  return (
    <IconButton onClick={onClick} className={classes}>
      {isViewTable ? (
        <>
          <DSIcon name="stats_figures" />
          <span>{trans('charts.button.toggle.chart-view')}</span>
        </>
      ) : (
        <>
          <DSIcon name="format_list_bulleted" />
          <span>{trans('charts.button.toggle.table-view')}</span>
        </>
      )}
    </IconButton>
  );
};

export default ToggleViewButton;
